
let prefix = '/api/user_plants';

function getID(id){
    return window.axios.get(prefix+'/getPlantsId/'+id);
}
function getIDNot(id){
    return window.axios.get(prefix+'/getPlantNotId/'+id);
}
function store(data){
    return window.axios.post(prefix+'/store', data);
}
function deleteUserPlant(id){
    return window.axios.delete(prefix+'/delete/'+id);
}
function updateManager(data){
    return window.axios.patch(prefix+'/update',data);
}

export default {
    getID, store, getIDNot, deleteUserPlant,updateManager
}